import axios from '../utils/request.js'

export function getReadyBiddingMessage(pageNum,pageSize) {
    return axios({
        url: '/zy4/'+pageNum+'/'+pageSize,
        method: 'get',
        withCredentials: true
    })
}

// 查询招标候选人
export function searchReadyMessage(searchVo) {
    return axios({
        url: '/zy4/search',
        method: 'POST',
        data: searchVo,
        withCredentials: true
    })
}
